import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.7_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/link.js");
